import angular from "angular"

const templateUrl = require("ngtemplate-loader!html-loader!./atenciones.component.html")

angular.module("fichaAlumnoModule").component("atenciones", {
  templateUrl: templateUrl,
  bindings: {
    alumnoId: "<",
    crear: "<",
    customCallback: "<",
    parentCallback: "<"
  },
  controller: [
    "EventoService",
    "EventoListService",
    "ComentarioService",
    "permissionService",
    function AtencionesController(
      EventoService,
      EventoListService,
      ComentarioService,
      permissionService
    ) {
      var self = this

      self.modelName = "atenciones"

      self._columns = [
        {
          key: "categoria",
          value: "Categoría"
        },
        {
          key: "plan_accion",
          value: "plan de acción"
        },
        {
          key: "tarea",
          value: "atención"
        },
        {
          key: "responsable",
          value: "responsable"
        },
        {
          key: "fecha_limite",
          value: "fecha límite"
        },
        {
          key: "estado_desc",
          value: "estado actual"
        },
        {
          key: "asistencia_desc",
          value: "asistencia"
        }
      ]

      self.menuOptions = [
        {
          name: "Finalizar Atención",
          callback: "editRow",
          args: "estado"
        },
        {
          name: "Ver Comentarios",
          callback: "custom",
          args: self.customCallback
        },
        {
          name: "Eliminar",
          callback: "deleteRow"
        }
      ]

      self.crudMenu = [
        {
          action: "crear",
          icon_name: "add",
          callback: "create"
        },
        {
          action: "eliminar",
          icon_name: "delete",
          callback: "delete"
        }
      ]

      if (!permissionService.eliminarAtenciones()) {
        self.menuOptions.splice(-1, 1)
        self.crudMenu.splice(-1, 1)
      }

      self.onCreate = function(post_data, callback) {
        post_data["matricula_id"] = self.alumnoId

        return EventoService.save(post_data).$promise.then(function(atencion_creada) {
          if (post_data.comentario !== "") {
            ComentarioService.save({
              object_pk: atencion_creada.id,
              modelName: "evento",
              comment: post_data.comentario
            }).$promise.then(function(data) {
              if (callback) {
                callback()
                if (self.parentCallback) {
                  self.parentCallback()
                }
              }
            })
          } else {
            if (callback) {
              callback()
            }
          }
        })
      }

      self.onEdit = function(models, callbackPromise) {
        return EventoService.update(models).$promise.then(function(data) {
          if (callbackPromise) {
            callbackPromise().then(function(response) {
              if (self.parentCallback) {
                self.parentCallback()
              }
            })
          }
          return { status: true }
        })
      }

      self.onDelete = function(models) {
        return EventoService.remove({ "ids[]": models }).$promise
      }

      self._getModels = function() {
        return EventoListService.query({ matricula_id: self.alumnoId }).$promise
      }
    }
  ]
})
